export const FETCH_DIAGNOSIS_LIST_REQUEST = "FETCH_DIAGNOSIS_LIST_REQUEST";
export const FETCH_DIAGNOSIS_LIST_SUCCESS = "FETCH_DIAGNOSIS_LIST_SUCCESS";
export const FETCH_DIAGNOSIS_LIST_FAILURE = "FETCH_DIAGNOSIS_LIST_FAILURE";
